var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SimpleModuleDashboard',{attrs:{"module-id":_vm.Modules.BCRA,"profile-id":_vm.Profiles.PERSONAL,"include-php-custom":"","actions":_vm.dashboardActions}})}
var staticRenderFns = []

export { render, staticRenderFns }